'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPadding(option) {
	if (option.indexOf('%') > -1) {
		return option;
	}
	if (option === 'widescreen') {
		return '56.25%';
	}
	if (option === 'standard') {
		return '75%';
	}
	if (option.indexOf(':') > -1) {
		option = option.split(':');
		option = option[1] / option[0];
		option = option * 100;
		return option + '%';
	}
	return option;
}
function getId(str) {
	str = str.split('/');
	str = str.pop();
	if (str.indexOf('?v=') > -1) {
		str = str.split('?v=')[1];
	}
	str = str.split('?')[0];
	str = str.split('&')[0];
	return str;
}

var YouTubeEmbed = function (_React$Component) {
	(0, _inherits3.default)(YouTubeEmbed, _React$Component);

	function YouTubeEmbed() {
		(0, _classCallCheck3.default)(this, YouTubeEmbed);
		return (0, _possibleConstructorReturn3.default)(this, (YouTubeEmbed.__proto__ || Object.getPrototypeOf(YouTubeEmbed)).apply(this, arguments));
	}

	(0, _createClass3.default)(YouTubeEmbed, [{
		key: 'render',
		value: function render() {
			var embedLink = this.props.prependSrc + getId(this.props.id) + this.props.appendSrc;
			return _react2.default.createElement(
				'div',
				{ style: {
						position: 'relative',
						paddingBottom: getPadding(this.props.aspectRatio),
						width: '100%',
						height: 0
					} },
				_react2.default.createElement('iframe', {
					width: this.props.width,
					height: this.props.width,
					src: embedLink,
					frameBorder: '0',
					allow: 'autoplay; encrypted-media',
					allowFullScreen: true,
					style: {
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%'
					}
				})
			);
		}
	}]);
	return YouTubeEmbed;
}(_react2.default.Component);

YouTubeEmbed.defaultProps = {
	aspectRatio: '56.25%',
	prependSrc: 'https://www.youtube.com/embed/',
	appendSrc: ''
};

exports.default = YouTubeEmbed;
module.exports = exports['default'];

//# sourceMappingURL=index.js.map